// extracted by mini-css-extract-plugin
module.exports = {"button":"styles__button___1VE1k","buttonCancel":"styles__buttonCancel___3NG3w styles__button___1VE1k","container":"styles__container___2Db-Z","actions":"styles__actions___FpzJa"};